export default __webpack_public_path__ + "static/media/Doc_Symbol_Icon.2980be19.svg";